import { Plug } from 'SharedDir/router/helpers';

export default [
  {
    path: 'dashboard',
    name: 'project-dashboard/:projectId',
    component: Plug,
    props: true,
  },
];
